<template>
	<el-table height="auto" ref="multipleTable" :data="tableData" @selection-change="handleSelectionChange" @select="pinSelect" :cell-class-name="cellClassName" @cell-click="cellClick">
		<el-table-column type="selection" width="55" :selectable="rowSelectable">
		</el-table-column>
		<el-table-column label="商品id" prop="spu" min-width="120">
		</el-table-column>
		<el-table-column label="站点" prop="channel" min-width="120">
		</el-table-column>
		<el-table-column label="选款规则" prop="rule" min-width="150">
			<template slot-scope="scope">
				{{scope.row.rule|findLabelByKey(recommendRules, 'value', 'label')}}
			</template>
		</el-table-column>
		<el-table-column label="品类" prop="category" min-width="150">
		</el-table-column>
		<el-table-column label="商品主图" min-width="150">
			<template slot-scope="scope">
				<div v-if="scope.row.image" class="table-img-box">
					<el-image :src="scope.row.image" :preview-src-list="[scope.row.image]"></el-image>
				</div>
			</template>
		</el-table-column>
		<el-table-column label="广告图片" min-width="250">
			<template slot-scope="scope">
				<div class="d-flex flex-row">
					<div>
						<img-radio v-if="scope.row.picAuto" :src="scope.row.picAuto"
							:checked="scope.row.originPic===true" @change="()=>changeSelected(scope.row, true)">
						</img-radio>
					</div>
					<div>
						<img-radio v-if="scope.row.picManual" :src="scope.row.picManual"
							:checked="scope.row.originPic===false"
							@change="()=>changeSelected(scope.row, false)"></img-radio>
					</div>
				</div>
			</template>
		</el-table-column>
		<el-table-column label="操作" min-width="80">
			<template slot-scope="scope">
				<update-img-button :data="scope.row"></update-img-button>
			</template>
		</el-table-column>
	</el-table>
</template>

<script>
	import MultipleTableSelection from '@/common/mixins/multiple-table-selection.js'
	import {mapGetters} from 'vuex'
	export default {
		mixins: [MultipleTableSelection],
		props: {
			tableData: {
				type: Array,
				default: []
			}
		},
		filters: {
			isSelected(row, multipleSelection) {
				return multipleSelection.find(v => v.id === row.id) !== undefined
			}
		},
		computed: {
			...mapGetters({
				recommendRules: 'fb-carousel-ads/recommendRules'
			})
		},
		methods: {
			changeSelected(row, originPic) {
				row.originPic = originPic
			},
			rowSelectable(row, index) {
				return (row.picAuto || row.picManual) !== null
			},
			isSelected(row) {
				return this.multipleSelection.find(v => v.id === row.id) !== undefined
			},
			cellClick(row, column, cell, event) {
				if (column.property === 'spu' || column.property === 'channel') {
					const selected = this.multipleSelection.find(v => v.id === row.id) !== undefined
					this.$refs['multipleTable'].toggleRowSelection(row, !selected)
				}
			}
		}
	}
</script>
